import { MetaData, MetaContent } from "./styles";

const metaData = [
    { key: 'immediateSubcategoryCount', getLabel: (count) => count === 1 ? 'category' : 'categories'},
    { key: 'immediateArticleCount', getLabel: (count) => count === 1 ? 'article' : 'articles' }
]

export const CategoryMeta = ({ categoryData }) => { 

    return (
    <MetaData>
        { 
          metaData.map( ({ key, getLabel }) => {
            const value = categoryData[ key ];
            if( !value ){
              return null;
            }
            return (
              <MetaContent key={key}>
                {value} {getLabel(value)}
              </MetaContent>
            )
          })
        }
    </MetaData>
    )
}